import type { IVariable, IVariableType } from '@carboncopyco/types';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { useState } from 'react';
import { AddRuleButton } from '../RulesManager';
import { VariableSelectionPopover } from './VariableSelectionPopover';

export interface AddVariableButtonProps {
  variables: IVariable[];
  onSelect: (variableType: IVariableType) => void;
}
export const AddVariableButton = ({
  variables,
  onSelect,
}: AddVariableButtonProps) => {
  const { editorRulesAndVarsLimit } = useFlags();

  const [popoverOpen, setPopoverOpen] = useState(false);

  const reachedLimit = variables.length >= editorRulesAndVarsLimit;

  return (
    <VariableSelectionPopover
      triggerElement={
        <AddRuleButton
          onClick={() => setPopoverOpen(true)}
          disabled={reachedLimit}
          tooltipMessage={
            reachedLimit &&
            `You reached the limit of ${editorRulesAndVarsLimit} variables`
          }
        />
      }
      onSelect={(variableType) => {
        onSelect(variableType);
        setPopoverOpen(false);
      }}
      open={popoverOpen}
      onOpenChange={setPopoverOpen}
    />
  );
};
